import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { CustomerDto } from '../dtos/customer.dto';
import { CustomValidators } from '../../../shared/validators/custom-validators';

export class CustomerFormFactory {
  static createCustomerForm(fb: FormBuilder, customerDto: CustomerDto): FormGroup {
    return fb.group({
      name: [customerDto.name, [Validators.required]],
      street: [customerDto.street, [Validators.required]],
      zipCode: [customerDto.zipCode, [Validators.required]],
      city: [customerDto.city, [Validators.required]],
      country: [customerDto.country, [Validators.required]],
      phone: [customerDto.phone, [CustomValidators.isoE164]],
      mobile: [customerDto.mobile, [CustomValidators.isoE164]],
      email: [customerDto.email, [Validators.required, Validators.email]],
      senderEmail: [customerDto.senderEmail],
      senderName: [customerDto.senderName]
    });
  }
}
